<template>
	<div>
		<CRow>
			<CCol sm="6">
				<h3>Caractéristiques</h3>
			</CCol>
			<CCol sm="6">
				<h3>Limites</h3>
			</CCol>
		</CRow>
		<CRow alignHorizontal="between">
			<CCol class="pannel pannel-left col-sm-6">
				<CRow>
					<CCol>
						<CSelect
							name="company"
							v-model="company"
							label="Compagnie aérienne"
							placeholder="Sélectionnez..."
							:options="companyList"
							ref="company"
							:value.sync="company"
							required />
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput
							type="text"
							label="LTA"
							name="LTA"
							:value="flight ? flight.LTA : ''"
							required />
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput
							type="text"
							label="Numéro de vol"
							name="reference"
							:value="flight ? flight.reference : ''"
							required />
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<vc-date-picker
							v-model="departureTime"
							:model-config="modelConfig"
							:masks="masks"
							mode="dateTime"
							is24hr>
							<template v-slot="{ inputValue, inputEvents }">
								<div role="group" class="form-group">
									<label for="departureTime-date">Départ LTA</label>
									<div class="input-group">
										<input
											id="departureTime-date"
											type="text"
											class="form-control"
											:value="$moment(inputValue).format('DD/MM/YYYY HH:mm')"
											v-on="inputEvents" />
										<input type="hidden" name="departureTime" :value="inputValue" />
										<div class="input-group-append">
											<span class="input-group-text">
												<CIcon name="cil-calendar" />
											</span>
										</div>
										<small class="form-text text-muted w-100"
											>Exemple: 06/12/2021 09:57</small
										>
									</div>
								</div>
							</template>
						</vc-date-picker>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<vc-date-picker
							v-model="arrivalTime"
							:model-config="modelConfig"
							:masks="masks"
							mode="dateTime"
							is24hr>
							<template v-slot="{ inputValue, inputEvents }">
								<div role="group" class="form-group">
									<label for="arrivalTime-date">Arrivée LTA</label>
									<div class="input-group">
										<input
											id="arrivalTime-date"
											type="text"
											class="form-control"
											:value="$moment(inputValue).format('DD/MM/YYYY HH:mm')"
											v-on="inputEvents" />
										<input type="hidden" name="arrivalTime" :value="inputValue" />

										<div class="input-group-append">
											<span class="input-group-text">
												<CIcon name="cil-calendar" />
											</span>
										</div>
										<small class="form-text text-muted w-100"
											>Exemple: 06/12/2021 09:57</small
										>
									</div>
								</div>
							</template>
						</vc-date-picker>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<vc-date-picker
							v-model="handoverTime"
							:model-config="modelConfig"
							:masks="masks"
							mode="dateTime"
							is24hr>
							<template v-slot="{ inputValue, inputEvents }">
								<div role="group" class="form-group">
									<label for="handoverTime-date">Date de remise</label>
									<div class="input-group">
										<input
											id="handoverTime-date"
											type="text"
											class="form-control"
											:value="$moment(inputValue).format('DD/MM/YYYY HH:mm')"
											v-on="inputEvents" />
										<input type="hidden" name="handoverTime" :value="inputValue" />

										<div class="input-group-append">
											<span class="input-group-text">
												<CIcon name="cil-calendar" />
											</span>
										</div>
										<small class="form-text text-muted w-100"
											>Exemple: 06/12/2021 09:57</small
										>
									</div>
								</div>
							</template>
						</vc-date-picker>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput
							type="string"
							label="Expéditeur"
							name="expeditor"
							:value="flight ? flight.expeditor : ''" />
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CSelect
							name="departureAirport"
							label="Aéroport de départ"
							placeholder="Sélectionnez..."
							:options="airportOptions.departure"
							:value.sync="departureAirport" />
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CSelect
							name="arrivalAirport"
							label="Aéroport de destination"
							placeholder="Sélectionnez..."
							ref="arrivalAirport"
							:options="airportOptions.arrival"
							:value.sync="arrivalAirport" />
					</CCol>
				</CRow>
			</CCol>
			<CCol class="pannel pannel-right col-sm-6">
				<CRow>
					<CCol>
						<CInput type="text" label="Limite poids" name="weightLimit" v-model="weightLimit">
							<template #append-content> KG </template>
						</CInput>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput type="text" label="Limite volume" name="volumeLimit" v-model="volumeLimit">
							<template #append-content> UV </template>
						</CInput>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput
							type="text"
							label="Limite quantité"
							name="quantityLimit"
							v-model="quantityLimit">
							<template #append-content> Nb </template>
						</CInput>
					</CCol>
				</CRow>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	export default {
		props: {
			flight: null | Object,
		},
		watch: {
			company: function (newVal, oldVal) {
				this.arrivalAirport = this.airports.find(
					airport => airport.oaciCode === this.companyAirportMap[newVal]
				)['@id'];
			},
		},
		data() {
			return {
				masks: {
					L: 'YYYY-MM-DD',
				},
				modelConfig: {
					type: 'string',
				},
				departureTime: this.flight
					? this.flight.departureTime
					: this.$moment().format('YYYY-MM-DD HH:mm'),
				arrivalTime: this.flight
					? this.flight.arrivalTime
					: this.$moment().format('YYYY-MM-DD HH:mm'),
				handoverTime: this.flight
					? this.flight.handoverTime
					: this.$moment().format('YYYY-MM-DD HH:mm'),
				companyAirportMap: { AIR_AUSTRAL: 'LFPG', CORSAIR: 'LFPO' },
				company: this.flight ? this.flight.company : null,
				departureAirport: this.flight ? this.flight.departureAirport['@id'] : null,
				arrivalAirport: this.flight ? this.flight.arrivalAirport['@id'] : null,
				weightLimit: this.flight ? this.flight.weightLimit : null,
				volumeLimit: this.flight ? this.flight.volumeLimit : null,
				quantityLimit: this.flight ? this.flight.quantityLimit : null,
				companyList: [
					{ value: 'AIR_AUSTRAL', label: 'Air Austral' },
					{ value: 'CORSAIR', label: 'Corsair' },
					{ value: 'AIR_FRANCE', label: 'Air France' },
					{ value: 'FRENCH_BEE', label: 'French Bee' },
				],
				airports: [],
				airportOptions: {
					departure: [],
					arrival: [],
				},
			};
		},
		methods: {
			getAirportsLists() {
				this.$axios
					.get('/api/airports')
					.then(res => {
						this.airports = res.data['hydra:member'];
						this.airportOptions.departure = [];
						this.airportOptions.arrival = [];

						this.airports.forEach(airport => {
							this.airportOptions[airport.type].push({
								value: airport['@id'],
								label: airport.name,
							});
						});
					})
					.catch(err => {
						this.$toast.error(
							"Nous n'avons pas pu récupérer la liste des aéroports, veuillez contactez un administrateur"
						);
					});
			},
		},
		mounted() {
			this.getAirportsLists();
		},
	};
</script>
<style>
	.pannel-left {
		border-right: 1px solid #ececec;
	}
</style>
